import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import styles from './Error.css';

class Error extends React.Component {

    render() {
        let content;
        let error = (
            <div>
                <div style={styles.title}>{this.props.title}</div>
                <div style={styles.subtitle}>{this.props.subtitle}</div>
            </div>
        );

        if (this.props.paper) {
            content = (
                <Paper style={styles.content}>
                    {error}
                </Paper>
            );
        } else {
            content = (
                <div style={styles.content}>
                    {error}
                </div>
            );
        }

        return content;
    }
}

Error.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    paper: PropTypes.bool
};

Error.defaultProps = {
    paper: false
};

export default Error;



// WEBPACK FOOTER //
// src/components/common/Error/Error.js